import ActionsDropdown from 'components/actions-dropdown/ActionsDropdown';
import { Dropdown } from 'react-bootstrap';

const MoreActionsDropdown = ({ member, actions }) => (
  <ActionsDropdown>
    {actions.map(action => (
      <Dropdown.Item
        key={action.actionLabel}
        onClick={() => action.onClick(member)}
        className={action.className}
      >
        {action.label}
      </Dropdown.Item>
    ))}
  </ActionsDropdown>
);

export default MoreActionsDropdown;
